export default __webpack_public_path__ + "static/media/UNMIS_UNMIS_SLA_Combatants_attend_meeting_of_head_of_UNMIS.4786acfb.jpg";